import { rootApi } from "../../api/rootApi";

export const walletTransferApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    bulkTransfer: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/walletTransfer/bulk-transfer`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    fetchWalletTransferBatchSummary: builder.mutation({
      query: (params) => {
        let url = `/tenant/walletTransfer/batch-summary?limit=${params.limit || 10}&offset=${params.offset || 0}`;
        if (params.startDate) url += `&startDate=${params.startDate}`;
        if (params.endDate) url += `&endDate=${params.endDate}`;

        return {
          method: "GET",
          url: url,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),

    fetchWalletTransferBatchDetails: builder.mutation({
      query: (params) => {
        let url = `/tenant/walletTransfer/details?batch_id=${params.batch_id}&limit=${params.limit || 20}&offset=${params.offset || 0}`;
        if (params.search) url += `&search=${params.search}`;
        if (params.status) url += `&status=${params.status}`;

        return {
          method: "GET",
          url: url,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
  }),
});

export const {
  useBulkTransferMutation,
  useFetchWalletTransferBatchSummaryMutation,
  useFetchWalletTransferBatchDetailsMutation,
} = walletTransferApi;
